import React from 'react'
import styled from 'styled-components'
import { Range } from 'react-range'
import { colors } from 'utils/colors'

interface Props {
  value: number
  max?: number
  min?: number
  step?: number
  buffered?: number
  onChange(value: number): void
  isFloating: boolean
}

const Slider: React.FC<Props> = ({ value, max = 100, min = 0, step = 1, buffered, onChange, isFloating }) => {
  const percentValue = ((value / max) * 100) | 0
  const percentBuffered = buffered ? ((buffered / max) * 100) | 0 : percentValue

  const onRangeChange = (values: number[]) => {
    onChange(values[0])
  }

  return (
    <Container>
      <Range
        values={[value]}
        step={step}
        min={min}
        max={max}
        onChange={onRangeChange}
        renderTrack={({ props, children }) => (
          <Track onMouseDown={props.onMouseDown} onTouchStart={props.onTouchStart}>
            <TrackBackground isFloating={isFloating} value={percentValue} buffered={percentBuffered} ref={props.ref}>
              {children}
            </TrackBackground>
          </Track>
        )}
        renderThumb={({ props }) => <Thumb isFloating={isFloating} {...props} />}
      />
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`

const Track = styled.div`
  display: flex;
  width: 100px;
  cursor: pointer;
`

const TrackBackground = styled.div<{ value: number; buffered: number; isFloating: boolean }>`
  height: 5px;
  width: 100%;
  border-radius: 4px;
  align-self: center;
  background: ${({ isFloating, theme, value, buffered }) =>
    !isFloating
      ? `linear-gradient(to right, 
          ${theme.colors.gray7} ${value}%, 
          ${theme.colors.gray6} ${value}% ${buffered}%,
          ${theme.colors.gray4} ${buffered}% 100%)`
      : `linear-gradient(to right, 
          ${theme.colors.white} ${value}%, 
          ${theme.colors.gray6} ${value}% ${buffered}%,
          ${theme.colors.gray6} ${buffered}% 100%)`};
`

const Thumb = styled.div<{ isFloating: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 12px;
  height: 12px;
  background: ${({ isFloating }) => (isFloating ? 'white' : colors.gray7)};
  border-radius: 50%;
  border: 1px solid ${(p) => p.theme.colors.gray8};
  transform: translate(-8.5px, -4px);

  &:focus {
    outline: none;
  }
`

export default Slider
